import React, { useState } from 'react';
import ApplicationsSignatureSC from './applications-signature.styled';
import Button from '../../ui/button';
import { BiggerText, SmallText, HeadingFour } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';
import DocumentsVerification from '../documents-verification';

const ApplicationsSignature = ({
  onClick,
  documents,
  onBoardingStepData,
  euroFormat,
  disabled,
}) => {
  const [areAllRead, setAllRead] = useState(false);

  const setDocumentsToAllRead = (status) => {
    setAllRead(status);
  };

  const formatAnswer = (valueName) => {
    const filteredItem = onBoardingStepData?.agrees?.filter((item) => item.name === valueName)[0];
    let isAgreed = filteredItem?.is_agreed;
    let formattedAnswer = '';
    if (isAgreed === true) {
      formattedAnswer = 'áno';
    } else {
      formattedAnswer = 'nie';
    }
    return formattedAnswer;
  };

  return (
    <ApplicationsSignatureSC>
      <DocumentsVerification
        documents={documents}
        setDocumentsToAllRead={(status) => setDocumentsToAllRead(status)}
      />
      <div className="additional-data-wrap">
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id="onboarding_applications_signature_loan_amount"
              defaultMessage={dlt['onboarding_applications_signature_loan_amount']}
            />
          </SmallText>
          <HeadingFour>{`${numeral(onBoardingStepData.loan_amount).format(
            euroFormat
          )} €`}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id="onboarding_applications_signature_number_of_payments"
              defaultMessage={dlt['onboarding_applications_signature_number_of_payments']}
            />
          </SmallText>
          <HeadingFour>
            {onBoardingStepData.number_of_payments}{' '}
            <FormattedMessage
              id="onboarding_applications_signature_months"
              defaultMessage={dlt['onboarding_applications_signature_months']}
            />
          </HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id="onboarding_applications_signature_installment_amount"
              defaultMessage={dlt['onboarding_applications_signature_installment_amount']}
            />
          </SmallText>
          <HeadingFour>{`${numeral(onBoardingStepData.monthly_payment).format(
            euroFormat
          )} €`}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id="onboarding_applications_signature_final_consumer"
              defaultMessage={dlt['onboarding_applications_signature_final_consumer']}
            />
          </SmallText>
          <HeadingFour>{formatAnswer('final_consumer')}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedHTMLMessage
              id="onboarding_applications_signature_politically_exposed"
              defaultMessage={dlt['onboarding_applications_signature_politically_exposed']}
            />
          </SmallText>
          <HeadingFour>{formatAnswer('politically_exposed')}</HeadingFour>
        </div>

        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedHTMLMessage
              id="onboarding_applications_signature_sanctioned_person"
              defaultMessage={dlt['onboarding_applications_signature_sanctioned_person']}
            />
          </SmallText>
          <HeadingFour>{formatAnswer('sanctioned')}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedHTMLMessage
              id="onboarding_applications_signature_own_interest"
              defaultMessage={dlt['onboarding_applications_signature_own_interest']}
            />
          </SmallText>
          <HeadingFour>{formatAnswer('own_interest')}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedHTMLMessage
              id="onboarding_applications_signature_standard_needs"
              defaultMessage={dlt['onboarding_applications_signature_standard_needs']}
            />
          </SmallText>
          <HeadingFour>{formatAnswer('standard_needs')}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedHTMLMessage
              id="onboarding_applications_signature_refinance"
              defaultMessage={dlt['onboarding_applications_signature_refinance']}
            />
          </SmallText>
          <HeadingFour>{formatAnswer('refinance')}</HeadingFour>
        </div>
        {onBoardingStepData.refinances?.length > 0 &&
          onBoardingStepData.refinances.map((refinance, index) => (
            <div className="additional-data-wrap--item" key={index}>
              <SmallText className="black-transparent-lighter smaller bolder">
                <FormattedMessage
                  id="onboarding_applications_signature_refinance_block"
                  defaultMessage={`Refinancovanie č. ${index + 1}`}
                />
                <br />
                {refinance.iban}
              </SmallText>
              <HeadingFour>
                {numeral(refinance.amount).format(euroFormat)} €
              </HeadingFour>
            </div>
          ))}
      </div>
      <div className="bottom-wrap">
        <BiggerText>
          <FormattedHTMLMessage
            id="onboarding_continue_hint"
            defaultMessage={dlt['onboarding_continue_hint']}
          />
        </BiggerText>

        <div className="half-wrap">
          <Button
            type="PRIMARY"
            disabled={areAllRead && !disabled ? false : true}
            onClick={() => onClick('accepted')}
          >
            <FormattedMessage id="global_continue" defaultMessage={dlt['global_continue']} />
          </Button>
          <Button
            type="OUTLINED"
            size="BIG"
            onClick={() => onClick('declined')}
            disabled={areAllRead && !disabled ? false : true}
          >
            <FormattedMessage
              id="global_return_to_merchant"
              defaultMessage={dlt['global_return_to_merchant']}
            />
          </Button>
        </div>

        <SmallText className="black-transparent-lighter">
          <FormattedMessage
            id="onboarding_documents_hint"
            defaultMessage={dlt['onboarding_documents_hint']}
          />
        </SmallText>
      </div>
    </ApplicationsSignatureSC>
  );
};

ApplicationsSignature.defaultProps = {
  euroFormat: '0,00.00',
};

export default ApplicationsSignature;
